import { Call } from "@mui/icons-material";
import { privateRequest, type ApiResponse } from "../axios";

export interface CustomerAdded {
  UserId: number;
  Name: string;
  Value: number;
  ProductiveVisits: number;
  IsManager: boolean;
  JointVisit: number;
}

export interface CallLogs {
  UserId: number;
  Name: string;
  Value: number;
  ProductiveVisits: number;
  IsManager: boolean;
  JointVisit: number;
}

export interface UserFilterPayload {
  FromDate: string; // consider Date if parsed
  ToDate: string; // consider Date if parsed
  IsManager: boolean;
  ManagerIds?: string; // comma-separated IDs
  SalesUserId: number | undefined;
  UserIds?: string; // comma-separated IDs
}

const ENDPOINTS = {
  LEADS_BY_STATUS: "api/CRM/Report/LeadsByStatus",
  LEADS_BY_STAGE: "api/CRM/Report/LeadsByStage",
  VISIT_CALENDAR: "api/CRM/Report/VisitCalendar",
  COVERAGE_REPORTS: "api/CRM/LeadCoverageReport",
  LEAD_FREQUENCY_VISIT_REPORT: "api/CRM/LeadFrequencyVisitReport",
  LEAD_FREQUENCY_VISIT_REPORT_EXPORT: "api/CRM/LeadFrequencyVisitReportExport",
  CUSTOMER_ADDED: "api/CRM/Report/LeadsAdded/Team",
  EXPORT_CUSTOMER_ADDED: "api/CRM/Report/LeadsAdded/Team/Export",
  CALL_LOGS: "/api/CRM/Report/CallLogs/Team",
  Call_LOGS_EXPORT: "/api/CRM/Report/CallLogs/Team/Export",
  VISIT_REPORT: "/api/CRM/Report/Visits/Team",
  VISIT_REPORT_EXPORT: "/api/CRM/Report/Visits/Team/Export",
  VISIT_CALENDAR_EXPORT: "api/CRM/Report/VisitCalendar/Export",
};

const getCustomerAdded = async (
  payload: UserFilterPayload,
): Promise<ApiResponse<CustomerAdded[]>> => {
  const res = await privateRequest.post<ApiResponse<CustomerAdded[]>>(
    ENDPOINTS.CUSTOMER_ADDED,
    payload,
  );
  return res.data;
};

const exportCustomerAdded = async (payload: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.EXPORT_CUSTOMER_ADDED,
    payload,
    { responseType: "arraybuffer" },
  );
  return res;
};

const getLeadsByStatus = async (payload: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.LEADS_BY_STATUS,
    payload,
  );
  return res.data;
};

const getLeadsByStage = async (payload: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.LEADS_BY_STAGE,
    { params: payload },
  );
  return res.data;
};

const getCallLogs = async (
  payload: UserFilterPayload,
): Promise<ApiResponse<CallLogs[]>> => {
  const res = await privateRequest.post<ApiResponse<CallLogs[]>>(
    ENDPOINTS.CALL_LOGS,
    payload,
  );
  return res.data;
};

const exportCallLogs = async (payload: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.Call_LOGS_EXPORT,
    payload,
    { responseType: "arraybuffer" },
  );
  return res;
};

const getVisitReport = async (
  payload: UserFilterPayload,
): Promise<ApiResponse<CustomerAdded[]>> => {
  const res = await privateRequest.post<ApiResponse<CustomerAdded[]>>(
    ENDPOINTS.VISIT_REPORT,
    payload,
  );
  return res.data;
};

const getCoverageReport = async (payload: any): Promise<any> => {
  const response = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.COVERAGE_REPORTS}`,
    payload,
  );
  return response.data;
};

const exportVisitReport = async (payload: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.VISIT_REPORT_EXPORT,
    payload,
    { responseType: "arraybuffer" },
  );
  return res;
};

const getLeadFrequencyVisitReport = async (payload: any): Promise<any> => {
  const response = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.LEAD_FREQUENCY_VISIT_REPORT}`, payload);
  return response.data;
}

const exportLeadFrequencyVisitReport = async (payload: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.LEAD_FREQUENCY_VISIT_REPORT_EXPORT,
    { params: payload, responseType: "arraybuffer" },
  );
  return res;
};

const getVisitCalendar = async (payload: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.VISIT_CALENDAR, { params: payload });
  return res.data;
};

const getVisitCalendarExport = async (payload: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.VISIT_CALENDAR_EXPORT, payload, { responseType: "arraybuffer" });
  return res;
};

const CustomerReportService = {
  getCustomerAdded,
  exportCustomerAdded,
  getLeadsByStatus,
  getLeadsByStage,
  getCoverageReport,
  getCallLogs,
  exportCallLogs,
  getVisitReport,
  exportVisitReport,
  getVisitCalendar,
  getLeadFrequencyVisitReport,
  exportLeadFrequencyVisitReport,
  getVisitCalendarExport,
};

export default CustomerReportService;
